import React from 'react';
import S from './TitleBlock.styles';
const TitleBlock = ({ align = 'left', size = 'large', subtitle, title, isInView = true, }) => {
    return (React.createElement(S.Container, { align: align, size: size, isActive: isInView },
        subtitle && (React.createElement(S.Subtitle, null,
            React.createElement("span", null, subtitle))),
        title && (React.createElement(S.Title, null,
            React.createElement("span", null, title)))));
};
export default TitleBlock;
